<template>
  <v-card>
    <v-card-title>
      <div>
        <h5>Hedef</h5>
        <h6 class="text-muted">Ciro Hedefim : <b>{{reportListData[0]?.targetLimit }}</b></h6>
        <h6 class="text-muted">Yapılan Ciro : <b>{{ reportListData[0]?.vatIncludedPrice }} ₺</b></h6>
      </div>
      <v-spacer></v-spacer>
      <slot></slot>
    </v-card-title>
    <div class="mb-2 ms-2 me-2" v-if="reportListData[0]">
    <v-progress-linear
        color="teal"
        background-color="green lighten-3"
        :value="reportListData[0]?.targetRate"
        height="20"
    >
      <template v-slot:default="{ value }">
        <strong style="color: white" class="fs-5">Tamamlama Yüzdesi: {{ parseInt(value) }}%</strong>
      </template>
    </v-progress-linear>
    </div>
<!--  <div class="bg-red progress h-7px bg-opacity-50 mt-7 me-5 ms-5 mb-5">-->
<!--    <div-->
<!--        class="bg-success progress-bar"-->
<!--        role="progressbar"-->
<!--        :style="`width: ${this.percent}%`"-->
<!--        aria-valuenow="50"-->
<!--        aria-valuemin="0"-->
<!--        aria-valuemax="100"-->
<!--    ></div>-->
<!--  </div>-->
  </v-card>
</template>
<script>
import {mapActions, mapState} from "vuex";
import {formatNum} from "leaflet/src/core/Util";

export default {
  name: "SalesPersonTargetBar",

  components: {},
  data() {
    return {
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("report",["reportListData","reportList"]),
  },
  mounted() {
this._fetchSalesPersonGiroReport();
  },
  methods: {
    formatNum,
    ...mapActions("report",["fetchReport"]),

    async _fetchSalesPersonGiroReport () {
      await this.fetchReport({
        reportType: "Hedef & Potansiyel Plasiyer Raporu",
        params: {
        },
        body: {
          startDate: "2023-01-01",
          finishDate: null,
          salesPersonCode: this.user.SalesPersonCode,
          reportDbName: null
        }
      })
}
  }
}
</script>

<style scoped>

</style>